import { Modal, Switch } from "antd";
import React from "react";

const { confirm } = Modal;

const FormulaSwitch: React.FC<IFormulaSwitch> = ({
  isActive,
  _id,
  handleUpdateFormulaStatus,
}) => {
  const handleSwitchChange = (checked: boolean) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"}?`,
      content: `This action will ${
        checked ? "enable" : "disable"
      } the formula.`,
      onOk() {
        handleUpdateFormulaStatus(_id, checked);
      },
      onCancel() {},
    });
  };

  return (
    <div>
      <Switch checked={isActive} onChange={handleSwitchChange} />
    </div>
  );
};

export default FormulaSwitch;
